import { render } from "./PatientsDatatableTDTags.vue?vue&type=template&id=38943fc6"
import script from "./PatientsDatatableTDTags.vue?vue&type=script&lang=js"
export * from "./PatientsDatatableTDTags.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__